import { toggleDrawer } from '@bibliocommons/ga-event-templates';
import DrawerConstants from '../constants/DrawerConstants';


function toggle() {
  return {
    type: DrawerConstants.TOGGLE,
    gaEvent: toggleDrawer()
  };
}

export default {
  toggle
};



// WEBPACK FOOTER //
// ./app/actions/DrawerActions.js